import { Box, InputBase, Typography, styled } from '@mui/material';
import { syntheticEvent } from 'lib/utils';
import PropTypes from 'prop-types';
import React from 'react';

const StyledInputBase = styled(InputBase)({
	width: '100%',
	'& input, & textarea': {
		'-webkit-appearance': 'none',
		'-moz-appearance': 'none',
		appearance: 'none',
		borderRadius: 4,
		backgroundColor: '#ffffff',
		padding: '8px 12px',
		minHeight: 28,
		transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
		border: '1px solid #ced4da',
		fontSize: 15,
		'&:focus': {
			boxShadow: '#90caf9 0 0 0 0.2rem',
			borderColor: '#90caf9'
		}
	}
});

const SearchInput = ({
	variant = 'outlined',
	margin,
	name,
	label,
	value,
	placeholder = 'Search...',
	onKeyPress,
	...props
}) => {
	const handleClearClick = () => {
		let e = syntheticEvent('', name);
		props.handleChange(e);
		if (props.handleClearClick) props.handleClearClick();
	};

	const handleChange = (ev) => {
		let { name, value } = ev.target;
		props.handleChange(ev);
	};

	return (
		<Box my={1}>
			{label && (
				<Typography variant="body2" color="textSecondary">
					{label}
				</Typography>
			)}
			<StyledInputBase
				type="text"
				fullWidth
				name={name}
				variant={variant}
				margin={margin}
				placeholder={placeholder}
				onKeyPress={onKeyPress}
				autoComplete="off"
				onChange={(e) => handleChange(e)}
				value={value}
			/>
		</Box>
	);
};

SearchInput.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	placeholder: PropTypes.string,
	handleChange: PropTypes.func.isRequired
};

export default SearchInput;
